<template>
  <div style="min-width: 1300px;">
  	
  
  	<div class="v2-banner" >
  		<p class="animated bounceIn" style="color: #E9E9E9;font-size: 30px;text-align: center;">国内最权威的</p>
  		<p class="animated bounceIn" style="color: #E9E9E9;font-size: 30px;text-align: center;margin-top: 20px;">专利管理机构和知识产权管理平台</p>
  		<p class="animated fadeInUp" style="color: #E9E9E9;font-size: 20px;text-align: center;margin-top: 70px;">
  			<span style="border-top:1px solid #B6B6B6;border-bottom:1px solid #A6A6A6;padding: 10px 50px;">
  					时刻保护您的专利数据安全
  			</span>
  		
  		</p>
  	</div>
  </div>
</template>

<script>
export default {
  name: 'banner',
  data:function(){
  	return {
  	}
  },
	components: {},
	methods:{
	}
}
</script>

<style scoped>
	.v2-banner{
		width: 100%;
		height: 480px;
		background: url(../../../../assets/v2/banner/banner.jpg);
		background-attachment: fixed;
		padding: 120px 150px 0px 150px;
	}
</style>



// WEBPACK FOOTER //
// src/view/v2/index/banner/index.vue